import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Variables de configuración de la aplicación
 */
export type AppConfig = {
  production: boolean;
  useMocks: boolean;
  identity: {
    useMocks: boolean;
  };
  backend: {
    baseUrl?: string;
    context: string;
  };
  laboratory?: {
    baseUrl?: string;
    context: string;
  };
};

/**
 * Token de inyección para la configuración de la aplicación
 */
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config', {
  providedIn: 'root',
  factory: () => environment
});
